/**
 * 更新跨服务感叹号按钮的显隐性<br/> props.button.toggleErrorStatus("错误按钮标识编码", isError: saga_status.value === "1",}); <br/><span style="color: red">与createErrorFlag配合使用</span>
 * @memberof Socket
 * @param {string} areaCode 错误按钮标识编码
 * @param {object} config 配置参数, 目前只有一个参数isError,值为true显示感叹号按钮，false不显示感叹号按钮<br>  
 */
export function toggleErrorStatus(areaId, data) {
    if (!this.myCrossServiceBtn[areaId]) { 
        return
    }
    let btnInstance = this.myCrossServiceBtn[areaId];
  
    let newState = { ...btnInstance.state, ...data };
    btnInstance.setState({
        isError: newState.isError,
        tipContent: newState.tipContent,
    })
}